import { createReducer } from './create';

const initialState = {
    selected_package: null,
    confirmed_package: null,

    step_packages_done: false,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: (state, payload) => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: (state, payload) => {
        return Object.assign({}, initialState, {
            selected_package: state.selected_package,
        });
    },
    ['PACKAGES/SELECT']: (state, payload) => {
        return Object.assign({}, state, {
            selected_package: payload.package,
        });
    },
    ['TICKETS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_package: payload.confirmed_package,
        });
    },
    ['TICKETS/SHOW_MORE']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_package: null,
        });
    },
});
